
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';


export default function About(props) {

    return (
        <Grid 
            container 
            height={{lg:'50vh',md:'50vh',sm:'50vh', xs:'auto'}}
            spacing={{lg: 5, md: 5, sm:3, xs:3}}
            direction="row"
            justifyContent="center"
            alignItems="center">
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Typography variant="h5" textAlign={{lg: 'end', md: 'end', sm:'end', xs:'start'}}>Hello,</Typography>
                <Typography variant="h4" textAlign={{lg: 'end', md: 'end', sm:'end', xs:'start'}}>I'm Stevry Bissa</Typography>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12} >
                <Typography variant="subtitle" textAlign='start'>
                    Research Engineer with 13 years of interest in software development. 
                    I have a diverse skill set and have utilized a variety of programming languages 
                    to develop software for research purposes across various fields. 
                    My ability to leverage multiple programming languages has enabled me to deliver 
                    high-quality multiplatform software solutions that meet the unique needs of each project. 
                    I am dedicated to staying up-to-date with the latest technology trends and 
                    committed to providing innovative and efficient software solutions.
                </Typography>
            </Grid>
        </Grid>

    )
}

